import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles(() => ({
    content: {
        padding: 0,
    },
}));
